import { Checkbox, MenuProps, TableColumnType } from 'antd';
import { ItemType } from 'antd/lib/menu/interface';

import { useColumnsVisibility } from '@/contexts/column-visibility';

export const useItems = <T,>(): MenuProps['items'] => {
    const { allColumns, visibleKeys, setVisibleKeys, requiredColumnsKeys, storageKey } =
        useColumnsVisibility<T>();

    const onToggle = (key: TableColumnType<T>['key']): void => {
        if (visibleKeys.includes(key)) {
            const updatedKeys = visibleKeys.filter((k) => k !== key);
            localStorage.setItem(storageKey, JSON.stringify(updatedKeys));
            setVisibleKeys(updatedKeys);
        } else {
            const updatedKeys = [...visibleKeys, key];
            localStorage.setItem(storageKey, JSON.stringify(updatedKeys));
            setVisibleKeys(updatedKeys);
        }
    };

    const [requiredItems, customizableItems] = allColumns.reduce<[ItemType[], ItemType[]]>(
        (acc, col) => {
            const title = typeof col.title === 'function' ? col.title({}) : col.title;
            const disabled = requiredColumnsKeys.includes(col.key);
            const item: ItemType = {
                type: 'item',
                key: col.key?.toString() || '',
                disabled,
                onClick: (e) => {
                    e.domEvent.preventDefault();
                    e.domEvent.stopPropagation();
                    if (!disabled) onToggle(col.key);
                },
                label: (
                    <Checkbox disabled={disabled} checked={visibleKeys.includes(col.key)}>
                        {title || col.key?.toString()}
                    </Checkbox>
                ),
            };

            if (disabled) acc[0].push(item);
            else acc[1].push(item);

            return acc;
        },
        [[], []]
    );

    return [...requiredItems, { type: 'divider' }, ...customizableItems];
};
